// Repair pipeline status colors
// 7-stage workflow: WORK ORDER → SHOP LOCATING → ESTIMATE → CUSTOMER APPROVED → IN PROGRESS → COMPLETED → INVOICE CREATED
export const STATUS_COLORS = {
  // ── Active pipeline ──
  open: 'text-[#3B82F6] bg-[#3B82F6]/10 border-[#3B82F6]/30',                              // Work Order Created
  estimate_requested: 'text-purple-400 bg-purple-900/20 border-purple-800/50',             // Repair Shop Locating
  estimate_received: 'text-yellow-400 bg-yellow-900/20 border-yellow-800/50',              // Estimate Received
  approved: 'text-teal-400 bg-teal-900/20 border-teal-800/50',                             // Customer Approved
  repair_in_progress: 'text-[var(--warning)] bg-[var(--warning-muted)] border-[var(--warning)]', // Repair In Progress
  completed: 'text-[#57EB31] bg-[#57EB31]/10 border-[#57EB31]/30',                         // Repair Completed
  invoice_created: 'text-cyan-400 bg-cyan-900/20 border-cyan-800/50',                      // Millennials Invoice Created
  // ── Legacy / aux ──
  draft: 'text-slate-400 bg-slate-900/20 border-slate-700/50',
  approval_pending: 'text-amber-400 bg-amber-900/20 border-amber-800/50',
  scheduled: 'text-indigo-400 bg-indigo-900/20 border-indigo-800/50',
  cancelled: 'text-red-400 bg-red-900/20 border-red-800/50',
  invoiced: 'text-cyan-400 bg-cyan-900/20 border-cyan-800/50',  // alias for back-compat
};

// Human-readable labels for the new pipeline
export const STATUS_LABELS = {
  open: 'Work Order Created',
  estimate_requested: 'Repair Shop Locating',
  estimate_received: 'Estimate Received',
  approved: 'Customer Approved',
  repair_in_progress: 'Repair In Progress',
  completed: 'Repair Completed',
  invoice_created: 'Invoice Created',
  // legacy / aux
  draft: 'Draft',
  approval_pending: 'Approval Pending',
  scheduled: 'Scheduled',
  cancelled: 'Cancelled',
  invoiced: 'Invoice Created',
};

export const PAYMENT_STATUS_COLORS = {
  pending: 'text-yellow-400 bg-yellow-900/20 border-yellow-800/50',
  paid: 'text-[#57EB31] bg-[#57EB31]/10 border-[#57EB31]/30',
  partial: 'text-amber-400 bg-amber-900/20 border-amber-800/50',
  overdue: 'text-red-400 bg-red-900/20 border-red-800/50',
  estimate_received: 'text-yellow-400 bg-yellow-900/20 border-yellow-800/50',
  pending_approval: 'text-amber-400 bg-amber-900/20 border-amber-800/50',
  unpaid: 'text-yellow-400 bg-yellow-900/20 border-yellow-800/50',
};

// 7-stage Repair Pipeline (in display order)
export const REPAIR_PIPELINE_STAGES = [
  { key: 'open',               label: 'Work Order Created',  short: 'Work Order' },
  { key: 'estimate_requested', label: 'Repair Shop Locating', short: 'Shop Locating' },
  { key: 'estimate_received',  label: 'Estimate Received',    short: 'Estimate' },
  { key: 'approved',           label: 'Customer Approved',    short: 'Approved' },
  { key: 'repair_in_progress', label: 'Repair In Progress',   short: 'In Progress' },
  { key: 'completed',          label: 'Repair Completed',     short: 'Completed' },
  { key: 'invoice_created',    label: 'Invoice Created',      short: 'Invoiced' },
];

// Active list (used by select dropdowns) — excludes cancelled
export const REPAIR_STATUSES = REPAIR_PIPELINE_STAGES.map(s => s.key);

export const formatStatus = (status) => {
  if (!status) return '';
  return STATUS_LABELS[status] || status.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
};
